import { SegmentPageTemplate } from 'src/components/pages/segment/SegmentPageTemplate';

import { useTechCarbonRemovalConfig } from './TechCarbonRemovalConfig';

export const TechCarbonRemovalPage = () => {
  const { isBundleLoading, config } = useTechCarbonRemovalConfig();

  return (
    <SegmentPageTemplate config={config} isBundleLoading={isBundleLoading} breadcrumbTitle={config?.heroAsset?.title} />
  );
};
